import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as  fromWebHookReducer from './webhook-reducer'

export const webHookState = createFeatureSelector<fromWebHookReducer.State>(
    fromWebHookReducer.webHookFeatureKey
)

export const selectWebHookList$ = createSelector(
    webHookState, (state) => state.webHookList
)

export const selectFailedTransactions$ = createSelector(
    webHookState, (state) => state.failedTransactions
)